/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:53:06]
Permissions to update outside the main branch: [false]
*/

import { Button, useActionsBtnContext } from '@finbeat/react-toolkit';
import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { usePingCrmApiCallback } from 'hooks/usePingCrmApiCallback';
import Id from 'models/id';
import { useTranslation } from 'react-i18next';
import 'scss/Main.scss';
import { useUserWorkplaceState } from '../Users';

type UserDeleteBtnProps = { isExternalUser: boolean } & Id;

export default function UserDeleteBtn({ id, isExternalUser }: UserDeleteBtnProps) {
    const { t } = useTranslation();
    const { deleteItemMutation } = useUserWorkplaceState();
    const { addRequest } = useActionsBtnContext();
    const pingCrm = usePingCrmApiCallback();

    return (
        <div>
            <Button
                className="workplace-delete-btn popover-btn"
                type="button"
                onClick={() => {
                    addRequest({
                        content: t('BackOfficeAreYouSure'),
                        confirmCallback: (res) => {
                            if (res && id !== undefined) {
                                if (isExternalUser) {
                                    deleteItemMutation.mutate({ id: id, crmSync: false });
                                } else {
                                    pingCrm((props) =>
                                        props.available
                                            ? id &&
                                              deleteItemMutation.mutate({ id: id, crmSync: true })
                                            : props.resp &&
                                              id &&
                                              deleteItemMutation.mutate({ id: id, crmSync: false })
                                    );
                                }
                            }
                        },
                    });
                }}
            >
                <FontAwesomeIcon icon={faTrashCan} className="workplace-action-btn__icon" />
                <span>{t('BackOfficeDeactivate')}</span>
            </Button>
        </div>
    );
}
